<a class="block block-bordered block-link-underline">
    <div class="block-content block-content-full clearfix">
      <div class="float-right" style="width:30%" >
          <ng-content select="[contact-logo]"></ng-content>
      </div>
      <div class="float-left text-left" style="width:70%">
        <div class="font-w600  mt-10 mb-5">
          <ng-content select="[contact-name]"></ng-content>
        </div>
        <div class="font-size-sm text-muted">
          <ng-content select="[contact-summary]"></ng-content>
        </div>
      </div>
    </div>
  </a>


// WEBPACK FOOTER //
// ./client/app/shared/blocks/user-block/user-block.component.html